import {select, takeLeading} from 'redux-saga/effects';
import {SERVER_CONFIG_BY_RESTAURANT_SUCCESS, SERVER_CONFIG_SUCCESS} from '../constants/api.constants';
import {getCurrentAppIdSelector, getCurrentRestaurantIdSelector, getCurrentServerConfig} from '../selectors';
import Config from '../config';
import {START} from '../constants/app-state.constants';
import {getStartupParams} from "../helpers/startup-params.helper";
import {setInfoMessage} from "../managers/client-log.manager";

function* applyManifestLink(action) {
	const state = yield select();

	const startupParams = getStartupParams();
	const currentServerConfig = getCurrentServerConfig(state);

	if (!(startupParams.restaurant || startupParams.app) || !currentServerConfig) return;

	if (startupParams.restaurant) {
		const currentRestaurantId = getCurrentRestaurantIdSelector(state);
		document.getElementById('manifest-link').href = Config.BaseServerUrl + `api/manifest/restaurant/${currentRestaurantId}/${Config.getAppVersion()}`;
		setInfoMessage('PWA: Restaurant manifest applied');
	} else if (startupParams.app) {
		const currentAppId = getCurrentAppIdSelector(state);
		document.getElementById('manifest-link').href = Config.BaseServerUrl + `api/manifest/app/${currentAppId}/${Config.getAppVersion()}`;
		setInfoMessage('PWA: App manifest applied');
	}

	document.getElementById('manifest-icon').href = currentServerConfig.pwaIcon;

	document.querySelectorAll('link[id*=manifest-splash-]').forEach(splashLinkElement => {
		splashLinkElement.href = currentServerConfig.pwaIcon;
	});
}

export const manifestLoaderSaga = function* manifestLoaderSaga() {
	yield takeLeading([START, SERVER_CONFIG_BY_RESTAURANT_SUCCESS, SERVER_CONFIG_SUCCESS], applyManifestLink);
};
